/**
 * Product-photo cache helpers for the standalone PWA.
 *
 * Product photos are cached by the service worker (workbox cacheName:
 * 'product-photos', StaleWhileRevalidate). After a marketing image is
 * regenerated on the server the SW can keep serving the old bytes until the
 * cache is cleared. Sync busts the cache and appends ?t= to every photo URL.
 */

import { API_BASE_URL } from './apiClient';

export const PRODUCT_PHOTOS_CACHE_NAME = 'product-photos';

/** Delete the SW product-photo cache so the next fetch hits the server. */
export async function clearProductPhotoCache(): Promise<void> {
  if (typeof window === 'undefined' || !('caches' in window)) return;
  try {
    await caches.delete(PRODUCT_PHOTOS_CACHE_NAME);
  } catch {
    // Non-fatal — URL cache-bust still forces a fresh network request.
  }
}

/** Build the product-photo URL, optionally with a sync cache-bust query param. */
export function productPhotoUrl(
  code: string | null | undefined,
  bust?: number | null,
): string {
  if (!code) return '';
  const base = `${API_BASE_URL}/api/branding/product-photo/${encodeURIComponent(code)}`;
  if (bust == null || bust === 0) return base;
  return `${base}?t=${bust}`;
}
